import React from 'react';

export const CommunityTest: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Community Test Page</h1>
        <p className="text-gray-600">This is a simple test to see if routing works.</p>
        <div className="mt-4 text-sm text-gray-500">
          If you can see this, the routing is working correctly.
        </div>
      </div>
    </div>
  );
};
















